import { backendPy } from "System/system";
import store from "System/reduxStore";
import { canonicals } from "Data/canonicals.js";
import { notify } from "Redux/user/actions";
import { getDateRange } from "Redux/data/actions";
// -------------------------------------------------------
// -------------------------------------------------------

// -------------------------------------------------------
// -------------------------------------------------------
export const mergeCollectionsIntoFrame = (cb) => async (dispatch) => {
  const { included, id, datapath } = store.getState().project;
  const projectid = id;

  const mandatoryCols = canonicals.filter((x) => x.isMandatory);


  await backendPy("collections", "merge", {
    datapath,
    projectid,
    collectionids: JSON.stringify(included),
    mandatory_cols: JSON.stringify(mandatoryCols),
  });
  dispatch({ type: "SET_HAS_MASTER" });
  dispatch(getDateRange());
  dispatch(notify("Master built successfully", 3500));
  cb();
};

// -------------------------------------------------------
// -------------------------------------------------------
export const buildFrame__can_erase = (cb) => async (dispatch) => {
  const { collections, repository, included, id, datapath } =
    store.getState().project;
  const projectid = id;
  for (const collection of collections) {
    if (included.includes(collection.id)) {
      const mapping = collection.mapping || {};
      const reverseMapping = Object.keys(mapping).reduce((acc, key) => {
        acc[mapping[key]] = key;
        return acc;
      }, {});
      console.log("---------");
      console.log(collection.title);
      console.log(collection.id);
      const custom = collection.custom || [];
      const customCols = custom.map((x) => x.key);
      const cols = [];
      for (const canonical of canonicals) {
        const mapType = reverseMapping.hasOwnProperty(canonical.header)
          ? "map"
          : "none";
        const mappedTo = reverseMapping[canonical.header];
        const isCustom = customCols.includes(mappedTo);
        const mappedValue = isCustom
          ? custom.find((x) => x.key === mappedTo).value
          : "";
        cols.push({
          ...canonical,
          mapType,
          mappedTo,
          isCustom,
          mappedValue,
        });
      }
      const allfiles = collection.fileids
        .map((id) => repository[id])
        .filter((file) => file.ext === "CSV");
      const files = JSON.stringify(allfiles.map((x) => x.name));
      const paths = JSON.stringify(
        allfiles.map((x) => x.path.replace(/\./g, ""))
      );
      const cuts = JSON.stringify(allfiles.map((x) => x.cut));

      const bundle = {
        projectid,
        collectionid: collection.id,
        collectionTitle: collection.title,
        cols,
        files,
        paths,
        cuts,
      };
      console.log("Building collection paquets");
      await backendPy("collections", "build", {
        bundle: JSON.stringify(bundle),
      });
      console.log("Merging collection paquets");
      await backendPy("collections", "merge", {
        collectionids: JSON.stringify(included),
        projectid,
        datapath,
      });
      console.log("Done");
    }
  }
  dispatch({ type: "SET_HAS_MASTER" });
  //dispatch(saveProject());
  cb();
};

// -------------------------------------------------------
// -------------------------------------------------------
const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const calculateAging = (cb) => async (dispatch) => {
  const { id } = store.getState().project;
  const projectid = id;
  console.log("Calculating aging", projectid);
  await sleep(1000);
  cb();
};
